/*
 * Generic System store
 */

import utils from '@/plugins/TravellerUtils';

const system = {
  namespaced: true,
  state: {
    travellerParameters: {
    }
  },
  mutations: {
    setTravellerParam(state, payload) {
      state.travellerParameters[payload[0]] = payload[1];
    },
  },
  actions: {
    getTravellerParameter(context, param) {
      return new Promise((resolve, reject) => {
        this._vm.$traveller_http.get('/traveller/restui/system/getTravellerParameter', { params: { "name": param } })
          .then(response => {
            if(utils.checkResponseObjectWithMemeber(response, 'value')) {
              context.commit('setTravellerParam', [param, response.data.value]);
              resolve(response.data);
            } else {
              reject("Could not get parameter");
            }
          }),
          error => {
            reject(error);
          }
      });
    },
    getDeviationColors(context) {
      return new Promise((resolve, reject) => {
        if(context.state.travellerParameters.VEHICLE_SCHEDULE_DEVIATION_COLORS != null) {
          resolve(context.state.travellerParameters.VEHICLE_SCHEDULE_DEVIATION_COLORS);
          return;
        }
        this._vm.$traveller_http.get('/traveller/restui/system/getVehicleScheduleDeviationColorParam')
          .then(response => {
            if(utils.checkResponseObjectWithMemeber(response, 'value')) {
              context.commit('setTravellerParam', ["VEHICLE_SCHEDULE_DEVIATION_COLORS", response.data.value]);
              resolve(response.data.value);
              return;
            } else {
              reject("Could not get parameter");
            }
          }),
          error => {
            reject(error);
          }
      });
    }
  }
}

export default system;
